import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d86bfa94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "player-container" }
const _hoisted_2 = { class: "mainBlock" }
const _hoisted_3 = { class: "player-add" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "heading" }, "新しい選手を登録", -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-check-icon" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "選手を登録", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "sideBlock" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-arrow-right arrowIcon" }, null, -1))
const _hoisted_11 = { class: "team-player-block" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "所属選手", -1))
const _hoisted_13 = {
  key: 0,
  class: "team-player-list"
}
const _hoisted_14 = {
  key: 1,
  class: "global-empty-text -small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "global-input",
          placeholder: "登録する選手名を入力",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.playerFormAdd.name) = $event))
        }, null, 512), [
          [_vModelText, _ctx.playerFormAdd.name]
        ]),
        _createElementVNode("button", {
          class: "global-button",
          disabled: !_ctx.playerFormAdd.isCompleted,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addPlayer && _ctx.addPlayer(...args)))
        }, _hoisted_8, 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        (_ctx.players.list.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.players.list, (player) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "item",
                  key: player.id
                }, [
                  _createVNode(_component_router_link, {
                    class: "link",
                    to: { name: 'playerDetail', params: { player_id: player.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(player.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_14, "登録されている選手がいません"))
      ])
    ])
  ]))
}